<div
	class="groups-students-list"
	[style.width]="width"
	[style.height]="height"
	[style.min-height]="minHeight"
	[style.max-height]="maxHeight"
	[style.border]="border"
	[style.border-bottom-right-radius]="borderBottomRightRadius"
	[style.border-bottom-left-radius]="borderBottomLeftRadius"
	[style.box-shadow]="boxShadow"
	[style.background]="background"
	[ngClass]="{ 'bottom-border': selectedNumber }">
	<mat-list [style.padding]="'8px'">
		<mat-list-item [style.padding]="'0'" *ngIf="showUploadStudentList" (click)="uploadStudentsEmit.emit()">
			<sp-upload-student-list></sp-upload-student-list>
		</mat-list-item>
		<ng-container *ngFor="let group of groups">
			<mat-list-item
				class="group"
				appCrossPointerEventTarget
				(mouseenter)="_item.hovered = true"
				(mouseleave)="_item.hovered = false; _item.pressed = false"
				(mousedown)="mouseDown.emit(true); _item.pressed = true"
				(mouseup)="_item.pressed = false"
				(pointerClickEvent)="onSelect(group)"
				[style.background-color]="getBackground(_item)"
				#_item>
				<div class="tw-flex tw-items-center tw-gap-2 tw-box-border tw-h-[52px] tw-cursor-pointer">
					<div class="tw-flex tw-items-center">
						<img class="tw-rounded-full" width="28" height="28" src="../../../../../assets/Groups Icon.svg" />
					</div>
					<div class="tw-flex tw-items-center tw-gap-1 tw-leading-none">
						<div class="tw-font-medium tw-text-navy-500 tw-text-[15px] tw-leading-none">{{ group.title }}</div>
						<div class="tw-font-light tw-text-sm tw-text-navy-500 tw-leading-none">{{ group.users.length }}&nbsp;students</div>
					</div>
					<div>
						<img
							*ngIf="canEditGroup && _item.hovered"
							class="edit-icon tw-cursor-pointer"
							src="../../../../../assets/Edit (Blue-Gray).svg"
							(click)="editGroup($event, group)" />
					</div>
				</div>
			</mat-list-item>
		</ng-container>
		<div *ngFor="let student of students" (mousedown)="mouseDown.emit(true)">
			<mat-list-item class="group" (click)="onSelect(student)">
				<div class="tw-animate-fadein-200 selection tw-gap-2 tw-items-center">
					<div *ngIf="student.profile_picture" class="tw-flex tw-items-center">
						<img class="tw-rounded-full" style="max-width: 28px; max-height: 28px" [src]="student.profile_picture" alt="Avatar" />
					</div>
					<div *ngIf="!student.profile_picture" class="tw-flex tw-items-center">
						<img class="tw-rounded-full" style="max-width: 28px; max-height: 28px" src="../../../../../assets/Avatar Default.svg" alt="Avatar" />
					</div>
					<div class="tw-flex tw-items-center tw-gap-1 tw-leading-none">
						<div class="tw-font-medium tw-text-navy-500 tw-text-[15px] tw-leading-none">{{ student.display_name }}</div>

						<!-- ACTIVITY OR CLASS ORIGIN -->
						<div *ngIf="originInfo[student.id]?.originStatus === 'ok'" class="student-origin">
							<div class="pinnable" [style.background]="originInfo[student.id]!.backgroundColor">
								<img
									draggable="false"
									[style.width]="'13px'"
									[style.height]="'13px'"
									[src]="originInfo[student.id]!.icon | resolveAsset"
									alt="ICON" />
							</div>
							<div class="text">
								{{ originInfo[student.id]!.roomName }}
							</div>
						</div>

						<!-- HAS SCHEDULES BUT ORIGIN MISSING -->
						<div
							*ngIf="hasSchedulesFF && formState && !isKiosk && !originInfo[student.id] && (scheduleService.currentPeriod$ | async)"
							class="student-origin"
							#_originMissing>
							<img
								cdkOverlayOrigin
								#originLocationOverlayTrigger="cdkOverlayOrigin"
								(mouseenter)="setStudentHoverState(student.id, true)"
								(mouseleave)="delayTooltipForStudentSelect(student, false)"
								draggable="false"
								class="missing-icon"
								src="../../../../../assets/important-circle (Yellow).svg"
								alt="ICON" />
							<div class="missing-text">Scheduled Room Missing</div>
							<ng-template
								cdkConnectedOverlay
								[cdkConnectedOverlayOrigin]="originLocationOverlayTrigger"
								[cdkConnectedOverlayOpen]="studentHoverStates[student.id] || studentTooltipHoverStates[student.id]">
								<div
									(mouseenter)="setStudentTooltipHoverState(student.id, true)"
									(mouseleave)="delayTooltipForTooltipHover(student, false)"
									#_originMissingTooltip>
									<app-origin-location-tooltip
										[@TooltipFadeInOut]="'visible'"
										[classes]="originInfo[student.id]"
										[period]="(scheduleService.currentPeriod$ | async)?.long_name || (scheduleService.nextPeriod$ | async)?.long_name"
										[padding]="'12px'"
										[student]="student"
										[width]="'198px'"
										[tooltipType]="'missing'"
										[dayType]="(scheduleService.scheduleGroup$ | async)?.day_name">
									</app-origin-location-tooltip>
								</div>
							</ng-template>
						</div>

						<!-- HAS SCHEDULES BUT MULTIPLE CURRENT CLASSES -->
						<div *ngIf="!isKiosk && hasSchedulesFF && originInfo[student.id]?.originStatus === 'error'" class="student-origin" #_originError>
							<img
								cdkOverlayOrigin
								#originErrorOverlayTrigger="cdkOverlayOrigin"
								(mouseover)="setStudentHoverState(student.id, true)"
								(mouseleave)="delayTooltipForStudentSelect(student, false)"
								draggable="false"
								class="error-icon"
								src="../../../../../assets/important-circle (Red).svg"
								alt="ICON" />
							<div class="error-text">Scheduled Room Error</div>
							<ng-template
								cdkConnectedOverlay
								[cdkConnectedOverlayOrigin]="originErrorOverlayTrigger"
								[cdkConnectedOverlayOpen]="studentHoverStates[student.id] || studentTooltipHoverStates[student.id]">
								<div
									(mouseenter)="setStudentTooltipHoverState(student.id, true)"
									(mouseleave)="delayTooltipForTooltipHover(student, false)"
									#_originErrorTooltip>
									<app-origin-location-tooltip
										*ngIf="true"
										[@TooltipFadeInOut]="'visible'"
										[classes]="originInfo[student.id]?.classes || []"
										[period]="(scheduleService.currentPeriod$ | async)?.long_name || (scheduleService.nextPeriod$ | async)?.long_name"
										[padding]="'12px'"
										[student]="student"
										[width]="'198px'"
										[tooltipType]="'error'"
										[dayType]="(scheduleService.scheduleGroup$ | async)?.day_name">
									</app-origin-location-tooltip>
								</div>
							</ng-template>
						</div>
					</div>
				</div>
			</mat-list-item>
		</div>
		<div *ngIf="students?.length === 0 && groups?.length === 0" class="no-results-found-container">
			No results found
			<p *ngIf="emptyStateString">{{ emptyStateString }}</p>
		</div>
	</mat-list>
</div>
